<template>
  <div class="about-company-page">
    <!-- 1. 顶部Banner -->
    <section class="hidden md:block relative w-full overflow-hidden">
      <img src="@/assets/about/Rectangle_50.png" alt="北京菌丰生物科技有限公司" class="w-full h-full object-cover">
      <div class="absolute inset-0 text-center top-[20%] text-white z-10">
        <h1 class="text-[clamp(2.5rem,5vw,4rem)] font-bold mb-3">北京菌丰生物科技有限公司</h1>
        <p class="text-[clamp(0.9rem,2vw,1rem)] max-w-lg text-center px-4 mx-auto">
          农菌+科技双轮驱动，菌菇产业迎黄金增长期</p>
      </div>
      <div class="absolute inset-0 bg-black/30"></div>
    </section>
    <section class="block md:hidden relative w-full overflow-hidden h-[80vh]">
      <!-- 背景图 -->
      <img src="@/assets/product/mb_bg6.png" class="absolute inset-0 w-[100%] h-[100%]" alt="" />
      <!-- 深色遮罩提升文字可读性 -->
      <div class="absolute inset-0 bg-black/15"></div>

      <div class="relative z-10 w-full pt-[20%] px-6 flex flex-col items-center text-white">
        <img src="@/assets/logo_H.png" alt="菌丰生物" class="mb-6">
        <!-- 主标题 -->
        <h2 class="text-[24px] font-bold mb-2 text-center">北京菌丰生物科技有限公司</h2>
        <!-- 描述文字 -->
        <p class="text-[10px] leading-6 text-center opacity-90 mb-10">
          政策 + 市场双轮驱动，蘑菇产业迎黄金增长期
        </p>
      </div>
    </section>
    <!-- 2. 公司介绍区 -->
    <section class="md:py-32 md:max-w-[56%] max-w-[94%] mx-auto px-4 relative">
      <div class="md:flex flex-col md:flex-row gap-12 items-start">
        <div class="w-full md:block hidden md:w-[50%] relative">
          <div class="text-[clamp(5rem,8vw,8rem)] font-extrabold text-[#41B56F] leading-[0.9]">
            <div class="ml-20">JUN</div>
            <div class="ml-36">FENG</div>
            <div class="ml-4">2016</div>
          </div>
        </div>
        <div class="block md:hidden">
          <img src="@/assets/about/image_1.png" alt="北京菌丰生物科技有限公司" class="w-full h-full object-cover">

        </div>
        <div class="w-full md:w-[50%]">
          <div class=" text-center md:hidden mt-6">

            <svg t="1776758926412" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg"
              p-id="2504" width="24" height="24">
              <path
                d="M660.8 959.6c-31.7 0-62.4-6.2-91.4-18.4-28-11.8-53.1-28.8-74.7-50.3-21.6-21.6-38.5-46.7-50.3-74.7-12.3-29-18.4-59.7-18.4-91.4 0-31.7 6.2-62.4 18.4-91.4 11.8-28 28.8-53.1 50.3-74.7 21.6-21.6 46.7-38.5 74.7-50.3 29-12.3 59.7-18.4 91.4-18.4 31.7 0 62.4 6.2 91.4 18.4 28 11.8 53.1 28.8 74.7 50.3 21.6 21.6 38.5 46.7 50.3 74.7 12.3 29 18.4 59.7 18.4 91.4 0 31.7-6.2 62.4-18.4 91.4-11.8 28-28.8 53.1-50.3 74.7-21.6 21.6-46.7 38.5-74.7 50.3-29 12.1-59.8 18.4-91.4 18.4z m0-437.5c-54.1 0-105 21.1-143.3 59.3-38.3 38.2-59.3 89.2-59.3 143.3 0 54.1 21.1 105 59.3 143.3 38.2 38.3 89.2 59.3 143.3 59.3 54.1 0 105-21.1 143.3-59.3 38.3-38.2 59.3-89.1 59.3-143.3 0-54.2-21.1-105-59.3-143.3-38.3-38.3-89.2-59.3-143.3-59.3z m0 0"
                p-id="2505" fill="#41B56F"></path>
              <path
                d="M739.9 757.3h-78.4c-8.9 0-16.1-7.2-16.1-16.1V596.3c0-8.9 7.2-16.1 16.1-16.1 8.9 0 16.1 7.2 16.1 16.1v128.8h62.3c8.9 0 16.1 7.2 16.1 16.1 0 9-7.2 16.1-16.1 16.1z m0 0"
                p-id="2506" fill="#41B56F"></path>
              <path
                d="M175.8 145.8h7.2c2.8 0 5.5 1.4 7.1 3.7l64.7 94.1h0.7v-89.3c0-4.7 3.8-8.6 8.6-8.6h3c4.7 0 8.6 3.8 8.6 8.6v114.5c0 4.7-3.8 8.6-8.6 8.6h-6.5c-2.8 0-5.5-1.4-7.1-3.7L188 178.4h-0.7v90.4c0 4.7-3.8 8.6-8.6 8.6h-3c-4.7 0-8.6-3.8-8.6-8.6V154.4c0.1-4.7 4-8.6 8.7-8.6zM310.2 145.8h77.4c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6h-57.3c-4.7 0-8.6 3.8-8.6 8.6v21.2c0 4.7 3.8 8.6 8.6 8.6h52.9c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6h-52.9c-4.7 0-8.6 3.8-8.6 8.6v24.7c0 4.7 3.8 8.6 8.6 8.6h60.5c4.7 0 8.6 3.8 8.6 8.6 0 4.7-3.8 8.6-8.6 8.6h-80.5c-4.7 0-8.6-3.8-8.6-8.6V154.4c-0.1-4.7 3.7-8.6 8.5-8.6zM423.7 145.8c3.9 0 7.4 2.7 8.3 6.5l24 96h0.7l25.2-96.1c1-3.8 4.4-6.4 8.3-6.4h7.8c3.9 0 7.3 2.6 8.3 6.4l25.2 96.1h0.7l24-96c1-3.8 4.4-6.5 8.3-6.5h4.6c5.7 0 9.8 5.5 8.2 10.9l-33 114.5c-1.1 3.7-4.4 6.2-8.2 6.2h-8.3c-3.9 0-7.3-2.6-8.3-6.4l-25-95.2h-0.7l-25 95.2c-1 3.8-4.4 6.4-8.3 6.4H452c-3.8 0-7.2-2.5-8.2-6.2l-32.9-114.5c-1.6-5.5 2.5-10.9 8.2-10.9h4.6zM568.3 398.9h-400c-0.6 0-1.1-0.5-1.1-1.1v-9.5c0-0.6 0.5-1.1 1.1-1.1h400c0.6 0 1.1 0.5 1.1 1.1v9.5c0 0.6-0.5 1.1-1.1 1.1zM343.2 513.8H168.3c-0.6 0-1.1-0.5-1.1-1.1v-9.5c0-0.6 0.5-1.1 1.1-1.1h174.8c0.6 0 1.1 0.5 1.1 1.1v9.5c0.1 0.6-0.4 1.1-1 1.1zM343.2 628.7H168.3c-0.6 0-1.1-0.5-1.1-1.1v-9.5c0-0.6 0.5-1.1 1.1-1.1h174.8c0.6 0 1.1 0.5 1.1 1.1v9.5c0.1 0.7-0.4 1.1-1 1.1zM343.2 743.7H168.3c-0.6 0-1.1-0.5-1.1-1.1v-9.5c0-0.6 0.5-1.1 1.1-1.1h174.8c0.6 0 1.1 0.5 1.1 1.1v9.5c0.1 0.6-0.4 1.1-1 1.1z"
                fill="#41B56F" p-id="2507"></path>
              <path
                d="M350.7 900.6c0-7-5.6-12.6-12.6-12.6H128.5c-18.2 0-33.1-13.7-33.1-30.6V122.7c0-16.9 14.8-30.6 33.1-30.6h488c18.2 0 33.1 13.7 33.1 30.6v297.9c0 7.5 6.1 13.6 13.6 13.6s13.6-6.1 13.6-13.6V122.7c0-30.8-27-55.9-60.3-55.9h-488c-33.2 0-60.3 25.1-60.3 55.9v734.6c0 30.8 27 55.9 60.3 55.9h209.6c6.9 0 12.6-5.7 12.6-12.6z"
                fill="#41B56F" p-id="2508"></path>
            </svg>
          </div>

          <h3 class="md:text-3xl text-lg md:text-left text-center font-bold  md:text-[#41B56F] mb-4">北京菌丰生物科技有限公司</h3>
          <div class="md:hidden">
            <div class="flex justify-around gap-8 my-4">
              <div class="flex items-center gap-2">
                <img class="w-6 h-6" src="@/assets/about/Frame.png" alt="">
                <div>
                  <div class="text-lg font-bold text-[#41B56F]">2016 <span class="text-xs text-gray-400"> 年</span></div>
                  <div class="text-[10px] text-gray-400">公司成立时间</div>
                </div>
              </div>
              <div class="flex items-center gap-2">
                <img class="w-6 h-6" src="@/assets/about/Frame_1.png" alt="">
                <div>
                  <div class="text-lg font-bold text-[#41B56F]">200 <span class="text-xs text-gray-400"> 家</span></div>
                  <div class="text-[10px] text-gray-400">服务客户</div>
                </div>
              </div>
            </div>
          </div>

          <p class="md:text-[#000] text-gray-600 text-sm mb-2 text-indent">
            北京菌丰生物科技有限公司成立于 2016 年，总部位于北京昌平科技园区，专注食用菌全产业链的高科技生物企业。<br>
          </p>
          <p class="md:text-[#000] text-gray-600 text-sm mb-2 text-indent">
            公司自主研发 JF-A 系列智能仿生仓，以温湿光气精准调控、自动化生产与云端数据管理，实现菌菇全年稳定高效生产。业务覆盖菌种培育、智能种植、加工销售与进出口贸易，主营秀珍菇、金耳、双孢菇、舞茸菇、杏鲍菇等，产品远销海内外。</p>
         <p class="md:text-[#000] text-gray-600 text-sm mb-2 text-indent">
            秉承 "科技兴菌、品质为本" 理念，以生物智造与数字农业革新食用菌生产模式，持续输出安全绿色菌菇产品，助力农业现代化。</p>
          <div class="hidden md:block">
            <div class="flex justify-end gap-8">
              <div class="flex items-center gap-2">
                <img class="" src="@/assets/about/Frame.png" alt="">
                <div>
                  <div class="text-3xl font-bold text-[#41B56F]">2016 <span class="text-xs text-gray-400"> 年</span>
                  </div>
                  <div class="text-xs text-gray-400">公司成立时间</div>
                </div>
              </div>
              <div class="flex items-center gap-2">
                <img src="@/assets/about/Frame_1.png" alt="">
                <div>
                  <div class="text-3xl font-bold text-[#41B56F]">200 <span class="text-xs text-gray-400"> 家</span></div>
                  <div class="text-xs text-gray-400">服务客户</div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="hidden md:block absolute top-[330px]">
        <img src="@/assets/about/image_29.png" alt="公司大楼" class="w-full mt-6 rounded shadow-sm">
      </div>
    </section>

    <!-- 3. 资质荣誉区 -->
    <section class="md:pt-48 md:pb-32 py-10  md:max-w-[56%] max-w-[94%] mx-auto md:px-4">
      <h3 class="hidden md:block text-4xl font-bold text-[#41B56F] text-center mb-4">资质荣誉</h3>
      <p class="hidden md:block text-gray-500 text-center text-base mb-12">
        北京菌丰生物科技有限公司持有多项行业核心资质，<br>
        建立了完善的质量管理体系，确保产品安全合规，品质卓越。
      </p>

      <!-- 轮播图片区域（样式完全不变） -->
      <!-- <div class="relative max-w-[80%] mx-auto">
        <div class="flex justify-center items-center gap-12 transition-all duration-5000">
          <img v-if="leftImg" :src="leftImg.url" :alt="leftImg.alt"
            class="w-36 h-56 rounded shadow-sm transition-all duration-5000">
          <img :src="centerImg.url" :alt="centerImg.alt"
            class="w-52 h-72 rounded shadow-sm scale-110 transition-all duration-5000">
          <img v-if="rightImg" :src="rightImg.url" :alt="rightImg.alt"
            class="w-36 h-56 rounded shadow-sm transition-all duration-5000">
        </div>
        <button class="absolute left-0 top-1/2 -translate-y-1/2 text-[#41B56F] hover:opacity-80 transition text-xl"
          @click="prev">
          ‹
        </button>
        <button class="absolute right-0 top-1/2 -translate-y-1/2 text-[#41B56F] hover:opacity-80 transition text-xl"
          @click="next">
          ›
        </button>
      </div> -->
      <!-- 资质荣誉轮播 修复版：图片可见 + 整体居中不靠左 -->
      <el-carousel class="hidden md:block max-w-[8100%] mx-auto" :interval="4000" type="card" height="300px"
        indicator-position="none" arrow="always">
        <el-carousel-item v-for="item in list" :key="item.url">
          <div class="flex justify-center items-center h-full">
            <img :src="item.url" :alt="item.alt" class="w-52 h-72 rounded shadow-sm object-contain">
          </div>
        </el-carousel-item>
      </el-carousel>

      <el-carousel class="md:hidden mx-auto" :interval="4000" type="card" height="150px" indicator-position="none"
        arrow="always">
        <el-carousel-item v-for="item in list" :key="item.url">
          <div class="flex justify-center items-center h-full">
            <img :src="item.url" :alt="item.alt" class="w-24 h-auto rounded shadow-sm object-contain">
          </div>
        </el-carousel-item>
      </el-carousel>
    </section>


    <section class="md:hidden max-w-[94%] mx-auto px-4">
      <div class="text-center">

        <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="18" height="18" rx="9" fill="#41B56F" />
          <path
            d="M13.444 14H4.55603C4.46528 14.0001 4.37589 13.978 4.29567 13.9356C4.21546 13.8932 4.14686 13.8318 4.09589 13.7569C4.04492 13.6819 4.01312 13.5956 4.00328 13.5055C3.99343 13.4155 4.00584 13.3243 4.03942 13.2402L5.15041 10.467C5.19158 10.3638 5.26283 10.2753 5.35494 10.213C5.44705 10.1507 5.55577 10.1175 5.66703 10.1176H6.77802C6.92534 10.1176 7.06664 10.176 7.17081 10.28C7.27499 10.3841 7.33351 10.5251 7.33351 10.6722C7.33351 10.8193 7.27499 10.9604 7.17081 11.0644C7.06664 11.1684 6.92534 11.2269 6.77802 11.2269H6.04476L5.37817 12.8907H12.5996L11.933 11.2269H11.222C11.0747 11.2269 10.9334 11.1684 10.8292 11.0644C10.725 10.9604 10.6665 10.8193 10.6665 10.6722C10.6665 10.5251 10.725 10.3841 10.8292 10.28C10.9334 10.176 11.0747 10.1176 11.222 10.1176H12.333C12.4442 10.1175 12.553 10.1507 12.6451 10.213C12.7372 10.2753 12.8084 10.3638 12.8496 10.467L13.9606 13.2402C13.9942 13.3243 14.0066 13.4155 13.9967 13.5055C13.9869 13.5956 13.9551 13.6819 13.9041 13.7569C13.8531 13.8318 13.7845 13.8932 13.7043 13.9356C13.6241 13.978 13.5347 14.0001 13.444 14ZM9 5.55853L9.71659 6.43485C9.93478 6.6527 10.0637 6.94401 10.0781 7.25176C10.0925 7.55951 9.99128 7.86155 9.79436 8.09874C9.57655 8.31048 9.28456 8.42897 8.98056 8.42897C8.67656 8.42897 8.38456 8.31048 8.16676 8.09874C7.96433 7.86362 7.8601 7.55984 7.8756 7.25018C7.89111 6.94052 8.02517 6.64863 8.25008 6.43485L8.48339 6.1409L8.96667 5.53635L9 5.55853ZM8.96667 4.00002C8.91946 3.99945 8.87268 4.00906 8.82954 4.0282C8.78639 4.04735 8.7479 4.07558 8.7167 4.11095C8.34451 4.53247 7.79457 5.22021 7.38351 5.74156C6.57804 6.74544 6.50582 8.02664 7.38351 8.89186C7.80924 9.30851 8.38163 9.54189 8.97778 9.54189C9.57393 9.54189 10.1463 9.30851 10.5721 8.89186C10.9707 8.46392 11.1923 7.90115 11.1923 7.31671C11.1923 6.73227 10.9707 6.16951 10.5721 5.74156C10.1388 5.18693 9.57772 4.52138 9.21109 4.11095C9.15454 4.05496 9.0795 4.02144 9 4.01666L8.96667 4.00002Z"
            fill="white" />
        </svg>

        <div class="text-enter text-3xl font-bold mt-4 mb-2">
          基地介绍
        </div>

      </div>

      <!-- 天津宝坻基地（设计图：左文字 右图片） -->
      <div class="w-full rounded-3xl pb-2 relative">
        <div class="pt-3">
          <h4 class="text-xl text-center font-bold text-[#41B56F]">
            天津宝坻 · 生态升级
          </h4>
          <!-- 标题+定位图标 完全匹配设计图 -->
          <p class="text-gray-600 text-xs leading-relaxed my-2 text-indent">
            依托 198 亩农业资源两期开发多品类栽培，探索「低空经济 + 智慧云仓」融合新模式，打造乡村振兴样板。
          </p>
          <!-- 按钮完全匹配设计图：圆角绿色+播放图标 -->
          <div @click="goDetail(1)" class="relative">
            <img src="@/assets/about/Frame_131.png" class="w-[88px] absolute top-0 left-[38%]" alt="">
            <span class="absolute z-10 text-white text-xs top-2 left-[40%]">查看详情 </span>
          </div>
        </div>
        <div class="mt-4">
          <img src="@/assets/about/image_17.png" alt="天津宝坻" class="scale-[0.9] w-full">
        </div>

      </div>

      <div class="w-full rounded-3xl pb-2 relative">
        <div class="pt-3">
          <h4 class="text-xl text-center font-bold text-[#41B56F]">
            重庆江津基地 · 工厂化典范
          </h4>
          <!-- 标题+定位图标 完全匹配设计图 -->
          <p class="text-gray-600 text-xs leading-relaxed my-2 text-indent">
            全流程自动化 + 智能环控，年产食用菌超 6 万吨、占据西南食用菌市场近七成份额。
          </p>
          <!-- 按钮完全匹配设计图：圆角绿色+播放图标 -->
          <div @click="goDetail(2)" class="relative">
            <img src="@/assets/about/Frame_131.png" class="w-[88px] absolute top-0 left-[38%]" alt="">
            <span class="absolute z-10 text-white text-xs top-2 left-[40%]">查看详情 </span>
          </div>
        </div>
        <div class="mt-4">
          <img src="@/assets/about/新对话_(1)_1.png" alt="重庆江津基地" class="scale-[0.9] w-full">
        </div>
      </div>

      <!-- 3. 客户案例区 -->
      <!-- <div class="mb-8 mt-4">
        <div class="text-center">
          <svg width="24" height="24" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clip-path="url(#clip0_111_816)">
              <path
                d="M7.075 7.44141C6.20635 7.44141 5.3897 7.10317 4.77549 6.48897C4.16128 5.87476 3.82305 5.05811 3.82305 4.18945C3.82305 3.3208 4.16128 2.50415 4.77549 1.88994C5.3897 1.27573 6.20635 0.9375 7.075 0.9375C7.94365 0.9375 8.7603 1.27573 9.37451 1.88994C9.98872 2.50415 10.327 3.3208 10.327 4.18945C10.327 5.05811 9.98872 5.87476 9.37451 6.48897C8.7603 7.10317 7.94365 7.44141 7.075 7.44141ZM7.075 1.875C5.79883 1.875 4.76055 2.91328 4.76055 4.18945C4.76055 5.46562 5.79883 6.50391 7.075 6.50391C8.35117 6.50391 9.38945 5.46562 9.38945 4.18945C9.38945 2.91328 8.35117 1.875 7.075 1.875ZM13.1283 14.0625H0.934082L0.937598 13.5902C0.94375 12.7674 1.10913 11.9695 1.42905 11.2188C1.73828 10.4933 2.17803 9.84214 2.73643 9.28345C3.29526 8.72432 3.94507 8.2853 4.66812 7.97871C5.41709 7.66099 6.21206 7.5 7.0312 7.5C7.85034 7.5 8.64531 7.66099 9.39429 7.97871C10.1172 8.2853 10.7671 8.72432 11.326 9.28345C11.8844 9.84214 12.3243 10.4933 12.6334 11.2188C12.9533 11.9695 13.1187 12.7674 13.1248 13.5902L13.1283 14.0625ZM1.89985 13.125H12.1625C11.9055 10.5004 9.69502 8.4375 7.0312 8.4375C4.36738 8.4375 2.15708 10.5004 1.89985 13.125ZM14.0623 9.84375H12.6561C12.3982 9.84375 12.1873 9.63281 12.1873 9.375C12.1873 9.11719 12.3982 8.90625 12.6561 8.90625H14.0623V9.84375ZM14.0623 7.5H11.8797C11.6219 7.5 11.4109 7.28906 11.4109 7.03125C11.4109 6.77344 11.6219 6.5625 11.8797 6.5625H14.0623V7.5ZM14.0623 5.15625H11.2498C10.992 5.15625 10.7811 4.94531 10.7811 4.6875C10.7811 4.42969 10.992 4.21875 11.2498 4.21875H14.0623V5.15625Z"
                fill="#41B56F" />
              <path
                d="M7.03135 13.1182L5.50146 11.3101L7.03149 8.43579L8.56108 11.3101L7.03135 13.1182ZM6.62764 11.1897L7.03135 11.6668L7.43506 11.1897L7.03135 10.4312L6.62764 11.1897Z"
                fill="#41B56F" />
            </g>
            <defs>
              <clipPath id="clip0_111_816">
                <rect width="24" height="24" fill="white" />
              </clipPath>
            </defs>
          </svg>

          <h3 class="text-2xl font-bold text-black text-center mb-3">客户案例</h3>

        </div>
        <p class="text-[#666] text-[12px] text-center mb-8">
          我们致力于与合作伙伴携手共赢，以诚信立业，以品质取胜，共创食用菌产业美好未来。
        </p>

        <div class="grid grid-cols-2 gap-2">
          <div class="bg-white rounded-lg overflow-hidden shadow-sm">
            <img src="@/assets/about/Rectangle_56.png" alt="上林县试验工场 - 舞茸菌" class="w-full h-auto object-cover">
            <div class="">
              <h4 class="font-bold text-[#41B56F] text-xs mb-1">上林县试验工场 - 舞茸菌</h4>
              <p class="text-gray-500 text-[8px]">2022年5月，1号试验工场 种植舞茸菌，取得成功。</p>
            </div>
          </div>

          <div class="bg-white rounded-lg overflow-hidden shadow-sm">
            <img src="@/assets/about/Rectangle_57.png" alt="武鸣县试验工场 - 秀珍菇" class="w-full h-auto object-cover">
            <div class="">
              <h4 class="font-bold text-[#41B56F] text-xs mb-1">武鸣县试验工场 - 秀珍菇</h4>
              <p class="text-gray-500 text-[8px]">2023年7月，武鸣县秀珍 菇实验，超实售。</p>
            </div>
          </div>
        </div>

      </div> -->
    </section>
  </div>
</template>

<script>
export default {
  name: "AboutCompanyPage",
  data() {
    return {
      current: 1, // 默认显示中间那张
      list: [
        { url: require('@/assets/about/image_11.jpg'), alt: '资质证书1' },
        { url: require('@/assets/about/image_12.jpg'), alt: '资质证书2' },
        { url: require('@/assets/about/image_13.jpg'), alt: '资质证书3' },
        { url: require('@/assets/about/image_14.jpg'), alt: '资质证书4' },
        { url: require('@/assets/about/image_15.jpg'), alt: '资质证书5' },
      ]
    }
  },
  computed: {

  },
  methods: {
    goDetail(id) {
      this.$router.push(`/about/base/detail?id=${id}`);
    }
  }
}
</script>

<style scoped>
/* 基础过渡效果 */


button {
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 1.5rem;
}

:deep(.el-carousel__arrow) {
  background: transparent !important;
  font-size: 28px !important;
  width: auto !important;
  height: auto !important;
}

:deep(.el-carousel__arrow--disabled) {
  color: #ccc !important;
}

:deep(.el-carousel__arrow:not(.el-carousel__arrow--disabled)) {
  color: #41B56F !important;
}
</style>